import moment from 'moment'
import { helper } from '@/utils'
import Logo from '../Logo/Logo.vue'
import Company from '../Company/Company.vue'

export default {
  name: 'Legal',
  components: { Company, Logo },
  computed: {
    isUpdated () {
      return this.legal.lastUpdate + '' !== '0'
    }
  },
  data () {
    return {
      component: 'legal',
      footer: {},
      legal: {},
      primaryColor: '#00BAFF'
    }
  },
  methods: {
    getData () {
      return Promise.all([this.getTheme(), this.getLegal()])
        .then(([theme, legal]) => {
          this.footer = {
            companyAddress: theme.company_address,
            companyContact: theme.company_contact,
            companyName: theme.company_name,
            companyUrl: theme.company_url
          }
          this.primaryColor = theme.primary_color

          this.legal = {
            content: legal.content,
            lastUpdate: legal.last_update,
            title: legal.title
          }
        })
        .catch((error) => helper.showErrorMessage(this, this.component, error))
    },
    getLegal () {
      return this.$api.getLegal()
        .then(({ body: values }) => ({
          content: values.body,
          last_update: this.setLastUpdated(values.last_update),
          title: values.title
        }))
    },
    getTheme () {
      return this.$api.getTheme()
        .then(({ body }) => body)
    },
    setLastUpdated (ts) {
      return ts ? moment(ts).format('MMMM, D, YYYY') : 0
    }
  },
  mounted () {
    this.getData()
  }
}



// WEBPACK FOOTER //
// ./src/assets/pages/Legal/Legal.js